// ECREDIT_SMS
export const REQUEST_CONFIRM_CODE = 'REQUEST_CONFIRM_CODE';
export const SEND_CONFIRM_CODE = 'SEND_CONFIRM_CODE';
export const SET_CONFIRM_SMS_CODE_FETCH = 'SET_CONFIRM_SMS_CODE_FETCH';
export const SET_INPUT_WARNING = 'SET_INPUT_WARNING';
export const SET_TIMER_START = '/confirmSMS/set-time-start';
export const SET_OTP_ID = '/confirmSMS/set-otp-id';
export const SET_FETCH_ERROR = 'set-fetch-error';
export const SET_VIEW_RESEND_BUTTON = 'set-view-resend-button';
export const SET_RESET_SMS_VERIFICATION = 'set-reset-sms-verificarion';

// TELEPONY
export const SET_TELEPONY_TIMER_START = 'set-telepony-time-start';
export const SET_TELEPONY_VIEW_RESEND_BUTTON = 'set-telepony-view-resend-button';
export const SET_TELEPONY_VIEW_TRYOUT_BUTTON = 'set-telepony-view-tryout-button';
export const SET_TELEPONY_VIEW_TIMEOUT_BUTTON = 'set-telepony-view-timeout-button';
export const SET_TELEPONY_TOTAL_RESEND_TRIES = 'set-telepony-total-resend-tries';
export const SET_TELEPONY_CURRENT_RESEND_TRIES = 'set-telepony-current-resend-tries';
export const SET_TELEPONY_SMS_CONFIRMED = 'set-telepony-sms-confirmed';
export const SET_TELEPONY_REQUEST_FETCHING = 'set-telepony-request-fetching';
export const SET_TELEPONY_AWAITING_STATE = 'set-telepony-awating-state';
export const SET_TELEPONY_WRONG_CODE_STATE = 'set-telepony-wrong-code-state';
export const SET_TELEPONY_GLOBAL_TIMEOUT_STATE = 'set-telepony-global-timeout-state';
